import React from 'react';
import { __ } from '../../../../utils/translation-service';
import { portal } from '../../../../utils/locale';
import { getAssetsPrefix } from '../../../../utils/buildVersion';
import styled from '@emotion/styled';

const LogoStyle = styled.img`
    max-height: 44px;
    @media (min-width: 768px) {
        max-height: 50px;
    }
`;

const assetPrefix = getAssetsPrefix();
export class HeaderNavbarBrand extends React.Component {
    render() {
        const logoImg = `${assetPrefix}/static/images/logos/${portal}.svg`;
        let loadingImg = `/wp-content/themes/dreamlines/assets/images/icons/loadingImage.gif`;
        loadingImg = logoImg;
        return (
            <a href="/" title={__('toHomePage')}>
                <LogoStyle
                    className="lazy"
                    src={loadingImg}
                    data-original={logoImg}
                    alt={__('greatCruisesManyDiscounts')}
                />
            </a>
        );
    }
}
